import { IStoreState } from '../types';

export const getAppVersion = (state: IStoreState) => state.global.appVersion;
export const getAppVersionDelay = (state: IStoreState) => state.global.appVersionDelay;

export const getRequiredTaxSaved = (state: IStoreState) => state.global.requiredTaxSaved;
export const getRenderServiceStatus = (state: IStoreState) => state.global.renderServiceStatus;
